/* eslint-disable max-lines */
import { get } from 'lodash';

import app from '../app';
import { itemsByCategory as buildingTypeItems } from './../enums/building-type';
import { itemsByCategory as classTypeItems } from './../enums/commercial-class-type';
import { itemsByCategory as statusTypeItems } from './../enums/building-status-type';
import { itemsByCategory as parkingTypeItems } from './../enums/parking-type';
import currencies from './../enums/currency';
import { BUSINESS_CENTER_CATEGORIES } from '../../../../shared/constants/categories';

const events = {
  attach: 'bsCenterService.attach',
  detach: 'bsCenterService.detach',
};

app.service('bsCenterService', [
  '$rootScope',
  '$q',
  'apiService',
  'categoryService',
  'addFormService',
  'addressService',
  function ($rootScope, $q, apiService, categoryService, addFormService, addressService) {
    const getBuildingType = (ad, buildingType) => {
      const configForCategory = buildingTypeItems['commercial'];

      if (configForCategory) {
        const allowedItems = buildingTypeItems.commercial.items;
        if (allowedItems.includes(buildingType)) {
          return buildingType;
        }
      }
    };

    const isClassTypeValid = (category, classType) => {
      const objectType = categoryService.getInfoByCategory(category).objectType;
      const items = (classTypeItems[objectType] || classTypeItems.default).items;

      return items.includes(classType);
    };

    const isStatusTypeValid = (category, statusType) => {
      const objectType = categoryService.getInfoByCategory(category).objectType;
      const items = (statusTypeItems[objectType] || statusTypeItems.default).items;

      return items.includes(statusType);
    };

    const setLifts = (ad, types) => {
      if (ad.building.liftTypes) {
        Object.keys(types).forEach(type => {
          ad.building.liftTypes.forEach(lift => {
            if (lift.type === type) {
              lift.count = types[type];
            }
          });
        });
      }
    };

    const flushLifts = (ad, types) => {
      const adLifts = get(ad, 'building.liftTypes', []);
      Object.keys(types).forEach(type => {
        adLifts.forEach(lift => {
          if (lift.type === type && lift.count === types[type]) {
            lift.count = undefined;
          }
        });
      });
    };

    const setInfrastructure = (ad, infrastructure) => {
      ad.building.infrastructure = {};
      for (const infKey in infrastructure) {
        if (infKey === 'flatList') {
          continue;
        }
        ad.building.infrastructure[infKey] = infrastructure[infKey];
      }
    };

    const flushInfrastructure = (ad, infrastructure) => {
      for (const infKey in infrastructure) {
        if (infKey === 'flatList') {
          continue;
        }
        if (ad.building.infrastructure[infKey] === infrastructure[infKey]) {
          ad.building.infrastructure[infKey] = false;
        }
      }
    };

    const setLand = (ad, land = {}) => {
      if (!ad.land) {
        ad.land = {};
      }
      ad.land.area = land.area;
      ad.land.type = land.ownershipType;
    };

    const flushLand = (ad, land = {}) => {
      if (!ad.land) {
        return;
      }
      if (ad.land.area === Number(land.area)) {
        ad.land.area = undefined;
      }

      if (ad.land.type === land.ownershipType) {
        ad.land.type = undefined;
      }
    };

    const inputTypeMapTo = {
      commonFromTheStreet: 'commonFromStreet',
      commonFromTheYard: 'commonFromYard',
      separateFromTheStreet: 'separateFromStreet',
      separateFromTheYard: 'separateFromYard',
    };

    const setInputType = (ad, inputType) => {
      ad.inputType = inputTypeMapTo[inputType];
    };

    const flushInputType = (ad, inputType) => {
      if (ad.inputType === inputTypeMapTo[inputType]) {
        ad.inputType = undefined;
      }
    };

    const getOpeningHours = (ad, openingHoursArr = []) => {
      const { from, to, roundTheClock } = openingHoursArr[0] || {};
      const hoursType = roundTheClock === true ? 'roundTheClock' : 'specific';

      return {
        from,
        to,
        type: hoursType,
      };
    };

    const setOpeningHours = (ad, openingHoursArr) => {
      // TODO: выяснить у Галкина
      // Несоответствие описанной схемы и результата ответа, например для ""Россия, Москва, Тверская улица, 3"
      // http://swagger.dev.cian.ru/?url=http://master.dev.cian.ru/swagger/addform_common.json#!/businessShoppingCenter/get_addform_v2_bs_centers
      ad.building.openingHours = getOpeningHours(ad, openingHoursArr);
      // TODO можно еще заполнить но это не описано в свагере, а приходит от сервера в ответе openingHours
      // ad.building.workingDaysType
    };

    const flushOpeningHours = (ad, openingHoursArr) => {
      if (angular.equals(ad.building.openingHours, getOpeningHours(ad, openingHoursArr))) {
        ad.building.openingHours = {};
      }
    };

    // eslint-disable-next-line no-unused-vars
    const setParking = (ad, parkingArr) => {
      const objectType = categoryService.getInfoByCategory(ad.category).objectType;
      const items = (parkingTypeItems[objectType] || parkingTypeItems.default).items;
      const parking = parkingArr[0] && items.includes(parkingArr[0].type) ? parkingArr[0] : {};
      const { type, placesCount, priceMonthly, currency: serverCurrency, isFree } = parking;
      const currency =
        serverCurrency && currencies.find(c => c.key === serverCurrency) ? serverCurrency : currencies[0].key;

      ad.building.parking = {
        type,
        placesCount,
        priceMonthly,
        currency,
        isFree,
      };
    };

    let bsCenterLatestData = {};

    function clearBsCenterFormData() {
      if (Object.keys(bsCenterLatestData).length === 0) {
        if (addFormService.ad && !addFormService.ad.building) {
          addFormService.ad.building = {};
        }

        return;
      }

      const ad = addFormService.ad;
      const building = ad ? ad.building : {};

      if (Object.keys(building).length === 0) {
        return;
      }

      if (building.name === bsCenterLatestData.name) {
        building.name = '';
      }

      if (building.buildYear === bsCenterLatestData.buildYear) {
        building.buildYear = undefined;
      }

      if (building.totalArea === Number(bsCenterLatestData.totalArea)) {
        building.totalArea = undefined;
      }

      if (building.developer === get(bsCenterLatestData, 'developers[0].name')) {
        building.developer = '';
      }

      if (building.managementCompany === get(bsCenterLatestData, 'data.managementCompanies[0].name')) {
        building.managementCompany = '';
      }

      if (building.ventilationType === bsCenterLatestData.ventilationType) {
        building.ventilationType = undefined;
      }

      if (building.conditioningType === bsCenterLatestData.conditioningType) {
        building.conditioningType = undefined;
      }

      if (building.extinguishingSystemType === bsCenterLatestData.extinguishingSystemType) {
        building.extinguishingSystemType = undefined;
      }

      if (building.heatingType === bsCenterLatestData.heatingType) {
        building.heatingType = undefined;
      }

      if (building.ceilingHeight === bsCenterLatestData.ceilingHeight) {
        building.ceilingHeight = undefined;
      }

      if (building.floorsCount === bsCenterLatestData.floorsTo) {
        building.floorsCount = undefined;
      }

      if (building.classType === bsCenterLatestData.buildingClassType) {
        building.classType = undefined;
      }

      if (building.type === bsCenterLatestData.buildingType) {
        building.type = undefined;
      }

      if (building.statusType === bsCenterLatestData.buildingStatusType) {
        ad.building.statusType = undefined;
      }

      if (ad.accessType === bsCenterLatestData.accessType) {
        ad.accessType = undefined;
      }

      flushLifts(ad, {
        lift: bsCenterLatestData.totalLiftCount,
        travelator: bsCenterLatestData.travelatorCount,
        escalator: bsCenterLatestData.escalatorCount,
      });

      flushInfrastructure(ad, bsCenterLatestData.infrastructure);
      flushLand(ad, bsCenterLatestData.land);
      flushInputType(ad, bsCenterLatestData.inputType);
      flushOpeningHours(ad, bsCenterLatestData.openingHours);
    }

    /**
     * Заполнить форму данными БЦ/ТЦ, и привязать БЦ к объявл.
     * @param data
     */
    this.fillBSCenterData = data => {
      const ad = addFormService.ad;

      bsCenterLatestData = angular.copy(data);

      ad.building = ad.building || {};

      ad.building.name = data.name;
      ad.building.buildYear = data.buildYear;
      ad.building.totalArea = data.totalArea ? Number(data.totalArea) : null;
      ad.building.developer = data.developers && data.developers[0] && data.developers[0].name;
      ad.building.managementCompany =
        data.managementCompanies && data.managementCompanies[0] && data.managementCompanies[0].name;
      ad.building.ventilationType = data.ventilationType;
      ad.building.conditioningType = data.conditioningType;
      ad.building.extinguishingSystemType = data.extinguishingSystemType;
      ad.building.heatingType = data.heatingType;
      ad.building.ceilingHeight = data.ceilingHeight;
      ad.building.floorsCount = data.floorsTo;

      ad.building.classType = isClassTypeValid(ad.category, data.buildingClassType)
        ? data.buildingClassType
        : undefined;
      ad.building.type = getBuildingType(ad, data.buildingType);
      ad.building.statusType = isStatusTypeValid(ad.category, data.buildingStatusType)
        ? data.buildingStatusType
        : undefined;
      ad.accessType = data.accessType;

      setLifts(ad, { lift: data.totalLiftCount, travelator: data.travelatorCount, escalator: data.escalatorCount });

      setInfrastructure(ad, data.infrastructure);
      setLand(ad, data.land);
      setInputType(ad, data.inputType);
      setOpeningHours(ad, data.openingHours);
      // setParking(ad, data.parkings);

      attachBS(data);
    };

    this.suggest = (term, geoId, geoType = 'location') => {
      return apiService.getBSCenters({ term, geoId, geoType }).then(data => data.data.bs_centers);
    };

    /**
     * Найти БЦ/ТЦ по адресу и заполнить форму.
     * @return promise(bsCenter) найденый БЦ/ТЦ или ничего
     */
    this.fillBSCenterDataByAddress = () => {
      if (!addressService.geoId || !addressService.geoType) {
        throw new Error('BSCenterService: адрес не выбран');
      }

      return apiService.getBSCenters({ geoId: addressService.geoId, geoType: addressService.geoType }).then(data => {
        if (data.data.bs_centers.length) {
          this.fillBSCenterData(data.data.bs_centers[0]);

          return data.data.bs_centers[0];
        }

        return $q.reject('bs_centers is empty');
      });
    };

    this.isBSCategory = inputCategory => {
      const category = inputCategory || addFormService.ad.category;

      if (category === 'officeRent' && addFormService.ad.coworkingOfferType) {
        return false;
      }

      return BUSINESS_CENTER_CATEGORIES.includes(category);
    };

    // Привязать объект к БЦ/ТЦ
    const attachBS = bsCenter => {
      const ad = addFormService.ad;
      if (!ad.businessShoppingCenter) {
        ad.businessShoppingCenter = {};
      }
      ad.businessShoppingCenter.id = bsCenter.id;
      triggerAttach(bsCenter);
    };

    // Отвязать объект от БЦ/ТЦ
    this.detachBSCenter = () => {
      clearBsCenterFormData();
      addFormService.ad.businessShoppingCenter = undefined;
      triggerDetach();
    };

    // привязан ли БЦ/ТЦ к объявлению
    this.isBSCenterAttached = () => {
      return !!(addFormService.ad.businessShoppingCenter && addFormService.ad.businessShoppingCenter.id);
    };

    /**
     * подписаться на привязку БЦ
     * @param handler обработчик function(bsCenter){}
     * @return функция для отписки
     */
    this.onAttach = handler => $rootScope.$on(events.attach, (event, ...args) => handler(...args));
    const triggerAttach = bsCenter => $rootScope.$emit(events.attach, bsCenter);

    /**
     * подписаться на отвязку БЦ
     * @param handler обработчик function(){}
     * @return функция для отписки
     */
    this.onDetach = handler => $rootScope.$on(events.detach, () => handler());
    const triggerDetach = () => $rootScope.$emit(events.detach);
  },
]);
